import styled from '@emotion/styled';

export const SectionTitle = styled.h2`
    color: ${({ theme }) => theme.colors.black[700]};
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.32px;
`;
